import { ResultObjectType } from '@cbgms/api'
import { ResultTitle } from './Title'
import { Box, Typography } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import { useTranslation } from 'react-i18next'
import { useCallback } from 'react'
import { VirtualSearchResultType } from './TopSearchResultType'
export interface CallToActionSearchPartsResultProps {
  Type: VirtualSearchResultType.CallToActionSearchParts
  query: string
  clearQuery: () => void
  primaryAction: () => Promise<void>
  hasGroupHeader: boolean
}

const CallToActionSearchPartsResult: React.FC<CallToActionSearchPartsResultProps> = ({ hasGroupHeader, query, primaryAction }) => {
  const { t } = useTranslation()

  const onClickViewParts = useCallback(
    (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
      e.stopPropagation()
      primaryAction()
    },
    [primaryAction]
  )

  return (
    <Box key='search-parts-with-query' sx={{ display: 'flex', cursor: 'pointer' }} onClick={onClickViewParts}>
      <SearchIcon fontSize='small' sx={theme => ({ color: theme.palette.LKQGrey.background.modest })} />
      <Box sx={{ ml: 0.5 }}>
        <ResultTitle resultType={ResultObjectType.Parts} isTitleVisible={!hasGroupHeader} />
        <Typography sx={{ pr: 1 }}>{t('global.search_products_now', { query })}</Typography>
      </Box>
    </Box>
  )
}

export default CallToActionSearchPartsResult
